module.exports = __webpack_public_path__ + "static/media/ScreenNotSupportedIcon.fad5689d.svg";